import { QuestionService } from '../../../data/services'
import { Question } from '../../../data/models'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { QuestionPresenter } from '../../../data/presenters'

export const QuestionConfig: IDataServiceConfig<Question> = {
  service: QuestionService,
  deps: [ModelRepository],
  endpoint: 'exams/questions',
  model: Question,
  presenter: QuestionPresenter,
  backend: 'uncached',
  mappings: [
    {
      classType: 'Question',
      jsonType: 'questions',
      propertyMapping: {
        minorTopics: {
          mapsTo: 'minor-topics',
          isCollection: true
        },
        majorTopic: {
          mapsTo: 'major-topic',
        },
        answerChoiceGroups: {
          isCollection: true
        },
        explanations: {
          isCollection: true
        },
        questionPrompts: {
          isCollection: true
        },
        createdAt: {
          transform: {
            toModel: (value) => new Date(value)
          }
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/question.config.ts